import { v4 as uuidv4 } from 'uuid'
import { action, computed, extendObservable, makeObservable } from 'mobx'

import { BLOCK_TYPES } from './constants'
import Settings from '@client/utils/Settings'

export class BlockModel {
  constructor(data = {}, editor) {
    makeObservable(this)
    this.id = uuidv4()
    this.type = data.type || BLOCK_TYPES.NULL
    this.settings = new Settings()
    this.blockId = data.blockId
    this.editor = editor

    extendObservable(this, {
      showToolbar: false,
      hideIcons: false,
    })
  }

  @action setShowToolbar = (val) => {
    this.showToolbar = val
  }

  @action setHideIcons = (val) => {
    this.hideIcons = val
  }

  // Mirrors the width self-heal check in serialize() below without building
  // the full serialized object, so a caller that only needs this (e.g.
  // Toolbar's render) doesn't turn into a MobX observer of every setting —
  // or, for a container block whose serialize() recurses into children, its
  // entire subtree (FE-1288).
  @computed get canSerialize() {
    const width = this.settings.get('width')
    return typeof width === 'undefined' || !!width
  }

  serialize = () => {
    if (!this.canSerialize) {
      return null
    }
    return {
      type: this.type,
      settings: this.settings.serialize(),
    }
  }

  restore = (data) => {
    this.settings.set(data.settings)
  }
}

export const NULL = new BlockModel()
